export const DAO_CODE = 'TRAINING_ATTENDANCES' + '_DAO';
